import React from 'react';
import PropTypes from 'prop-types';
import _groupBy from 'lodash/groupBy';

import RenderGuestRow from './RenderGuestRow';

const RenderGuests = props => {
  const { fields, guestFormValues, onAddGuest } = props;
  const guestsByRelationshipType = _groupBy(fields.getAll(), guest => guest.relationship_type);
  const enablePlusOne = !guestsByRelationshipType.PARTNER;

  return (
    <div>
      <div className="row hidden-xs hidden-sm">
        <div className="col-md-2">
          <div className="form-label">Title</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">First Name</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">Last Name</div>
        </div>
        <div className="col-md-2">
          <div className="form-label">Suffix</div>
        </div>
      </div>
      {fields.map((guestNameField, guestIndex, guestFieldsRef) => (
        <RenderGuestRow
          key={guestIndex}
          name={guestNameField}
          index={guestIndex}
          fields={guestFieldsRef}
          enablePlusOne={enablePlusOne}
          guestFormValues={guestFormValues}
          onAddGuest={onAddGuest}
        />
      ))}
    </div>
  );
};

RenderGuests.propTypes = {
  fields: PropTypes.shape({}),
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  onAddGuest: PropTypes.func,
};

export default RenderGuests;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderGuests.jsx